import styled from "@emotion/styled";
import { Box, systemWidth } from "@kaltura/mediaspace-shared-styled";

export const ChannelsContainer = styled(Box)(({ theme }) => ({
    "&": systemWidth({ theme }),
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
        marginRight: 0,
    },
}));

export const IconsContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: theme.spacing(4),
    marginTop: theme.spacing(4),
    [theme.breakpoints.down(theme.breakpoints.values.lg)]: {
        gap: theme.spacing(2),
    },
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
        marginTop: theme.spacing(3),
        flexWrap: "nowrap",
        overflowX: "auto",
        justifyContent: "flex-start",
        scrollbarWidth: "none" /* Hide scrollbar for Firefox */,
        "&::-webkit-scrollbar": {
            /* Hide scrollbar for Chrome, Edge, Safari and Opera */ display: "none",
        },
    },
}));
